import {BaseContainerModel} from '../../base-container.model';
import {bl_cms_website_region_hdr_RowClass} from '../../../dbschema';

export class WebsiteRegionContainerModel extends BaseContainerModel {

  bl_cms_website_region_hdr: bl_cms_website_region_hdr_RowClass = new bl_cms_website_region_hdr_RowClass();
}
